import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button, Checkbox } from '@nazka/nazka.mapframe.components';

import Modal from '@App/components/Modal/Modal';

import './welcome.css';

function Welcome() {
  const navigate = useNavigate();
  const cookieValue = useSelector(state => state.cookies.cookieValue);
  const [isOpen, setIsOpen] = useState(false);
  const [isDismissed, setIsDismissed] = useState(localStorage.getItem('welcomeMessageDismissed') === 'true');

  useEffect(() => {
    if (localStorage.getItem('welcomeMessageDismissed') === 'true') {
      return;
    }

    const topElement = document.elementFromPoint(1, 1);
    const hasCookies = topElement?.closest('.nazka-cookies') !== null;

    if (!hasCookies) {
      setIsOpen(true);
    }
  }, [cookieValue]);

  useEffect(() => {
    if (!isOpen) {
      document.body.style.overflow = 'hidden';
      if (isDismissed) localStorage.setItem('welcomeMessageDismissed', 'true');
    }
  }, [isOpen, isDismissed]);

  return (
    <Modal
      title="Welkom bij de aquathermietool Vlaanderen!"
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      closeOnOverlayClick={false}
      closeOnEscape={false}
      className="welcome"
      maxWidth="1200px"
    >
      <div className="welcome__content">
        <p>Deze aquathermietool geeft een overzicht van het aquathermiepotentieel in Vlaanderen. Aquathermie is een duurzame energiebron waarbij warmte uit oppervlakte-, drink- of afvalwater wordt benut voor verwarming van gebouwen.</p>
        <p>Met deze kaart willen we beleidsmakers, projectontwikkelaars, studiebureaus en andere belanghebbenden ondersteunen bij het inschatten van de mogelijkheden voor aquathermie in hun regio.</p>
        <p>Dit project is mede mogelijk gemaakt door de volgende partners:</p>
        <div className="welcome__content__logos">
          <a className="welcome__content__logos__logo" href="https://vmm.vlaanderen.be/" target="_blank" rel="noreferrer">
            <img
              className="welcome__content__logos__logo__img"
              src="./img/logo/vmm.png"
              alt="VMM"
            />
          </a>
          <a className="welcome__content__logos__logo" href="https://omgeving.vlaanderen.be/nl" target="_blank" rel="noreferrer">
            <img
              className="welcome__content__logos__logo__img"
              src="./img/logo/departement_omgeving.png"
              alt="Departement Omgeving"
            />
          </a>
          <a className="welcome__content__logos__logo" href="https://www.vlaio.be/nl" target="_blank" rel="noreferrer">
            <img
              className="welcome__content__logos__logo__img"
              src="./img/logo/VLAIO.png"
              alt="VLAIO"
              style={{ height: '32px' }}
            />
          </a>
          <a className="welcome__content__logos__logo" href="https://www.vlaamsewaterweg.be/nl" target="_blank" rel="noreferrer">
            <img
              className="welcome__content__logos__logo__img"
              src="./img/logo/de-vlaamse-waterweg.png"
              alt="De Vlaamse Waterweg"
              style={{ height: '27px' }}
            />
          </a>
          <a className="welcome__content__logos__logo" href="https://www.northseaport.com/nl" target="_blank" rel="noreferrer">
            <img
              className="welcome__content__logos__logo__img"
              src="./img/logo/north-sea-port.png"
              alt="North Sea Port"
            />
          </a>
          <a className="welcome__content__logos__logo" href="https://www.portofantwerpbruges.com/" target="_blank" rel="noreferrer">
            <img
              className="welcome__content__logos__logo__img"
              src="./img/logo/port-of-antwerp-bruges.png"
              alt="Port of Antwerp-Bruges"
              style={{ height: '27px' }}
            />
          </a>
          <a className="welcome__content__logos__logo" href="https://www.provincieantwerpen.be/nl" target="_blank" rel="noreferrer">
            <img
              className="welcome__content__logos__logo__img"
              src="./img/logo/antwerpen.png"
              alt="Provincie Antwerpen"
              style={{ height: '90px' }}
            />
          </a>
          <a className="welcome__content__logos__logo" href="https://oost-vlaanderen.be/" target="_blank" rel="noreferrer">
            <img
              className="welcome__content__logos__logo__img"
              src="./img/logo/oost-vlaanderen.png"
              alt="Provincie Oost-Vlaanderen"
              style={{ height: '35px' }}
            />
          </a>
          <a className="welcome__content__logos__logo" href="https://www.west-vlaanderen.be/" target="_blank" rel="noreferrer">
            <img
              className="welcome__content__logos__logo__img"
              src="./img/logo/west-vlaanderen.png"
              alt="Provincie West-Vlaanderen"
              style={{ height: '100px' }}
            />
          </a>
          <a className="welcome__content__logos__logo" href="https://www.vlaamsbrabant.be/nl" target="_blank" rel="noreferrer">
            <img
              className="welcome__content__logos__logo__img"
              src="./img/logo/vlaams-brabant.png"
              alt="Provincie Vlaams-Brabant"
              style={{ height: '36px' }}
            />
          </a>
          <a className="welcome__content__logos__logo" href="https://www.limburg.be/" target="_blank" rel="noreferrer">
            <img
              className="welcome__content__logos__logo__img"
              src="./img/logo/limburg.png"
              alt="Provincie Limburg"
              style={{ height: '38px' }}
            />
          </a>
        </div>
        <p>En werd gerealiseerd door:</p>
        <div className="welcome__content__logos">
          <a className="welcome__content__logos__logo" href="https://www.swecobelgium.be/" target="_blank" rel="noreferrer">
            <img
              className="welcome__content__logos__logo__img"
              src="./img/logo/sweco.png"
              alt="SWECO"
              style={{ height: '22px' }}
            />
          </a>
          <a className="welcome__content__logos__logo" href="https://www.extraqt.be/" target="_blank" rel="noreferrer">
            <img
              className="welcome__content__logos__logo__img"
              src="./img/logo/extraqt.png"
              alt="Extraqt"
              style={{ height: '22px' }}
            />
          </a>
          <a className="welcome__content__logos__logo" href="https://nazka.be/nl" target="_blank" rel="noreferrer">
            <img
              className="welcome__content__logos__logo__img"
              src="./img/logo/logo-nazka.svg"
              alt="Nazka"
              style={{ height: '25px' }}
            />
          </a>
        </div>
        <p>
          {'Wil je meer weten over aquathermie? Bekijk dan zeker even '}
          <a onClick={() => {
            navigate('/info');
            setIsOpen(false);
          }}
          >
            onze infopagina
          </a>
          .
        </p>
        <p>
          Wil je een korte rondleiding door de functionaliteiten van deze kaart?
          Klik op
          {' '}
          &quot;
          <span>Start begeleide tour</span>
          &quot;
          {' '}
          om op weg geholpen te worden.
        </p>
      </div>
      <div className="welcome__footer">
        <div className="welcome__footer__buttons">
          <Button
            className="welcome__footer__buttons__button"
            disabled
          >
            Start begeleide tour
          </Button>
          <Button
            className="welcome__footer__buttons__button"
            onClick={() => {
              setIsOpen(false);
            }}
            layout="outlined"
          >
            Direct aan de slag
          </Button>
        </div>
        <Checkbox
          className="welcome__footer__checkbox"
          text="Toon dit bericht niet meer bij het opstarten"
          onInputChange={() => {
            setIsDismissed(!isDismissed);
          }}
          checked={isDismissed}
        />
      </div>
    </Modal>
  );
}

export default Welcome;
